module.exports = "/shifts/directives/shift-history-777fc2.html";